angular.module('impactx.attributes').controller('PatCtrl', ['$scope', 'TranslationService', PatController]);

function PatController($scope, TranslationService) {
    var self = this;
    $scope.yes = TranslationService.get("yes");
    $scope.no = TranslationService.get("no");
    $scope.enterDateLabel = TranslationService.get("enterDate");

    self.checkForErrors = function () {
        $scope.errorList.length = 0;
        for (var i = 0; i < $scope.patAttributes.booleanSettings.length; i++) {
            var setting = $scope.patAttributes.booleanSettings[i];
            if (setting.value == null && setting.required) {
                $scope.errorList.push(TranslationService.get('fillRequiredFieldMessage').replace("^0", setting.label));
            }
        }
    };
    if ($scope.patAttributes.booleanSettings) {
        for (var i = 0; i < $scope.patAttributes.booleanSettings.length; i++) {
            (function() {
                var setting = $scope.patAttributes.booleanSettings[i];
                if (setting.required) {
                    $scope.$watch(function () {
                        return setting.value;
                    }, function () {
                        self.checkForErrors();
                    });
                }
            })();
        }
    }

    function compare(a, b) {
        if (a.priority < b.priority){
            return 1;
        }
        if (a.priority > b.priority){
            return -1;
        }
        return 0;
    }

    $scope.orderedSettings = [];
    $scope.initOrderSettings = function () {
        $scope.orderedSettings = $scope.orderedSettings
            .concat($scope.patAttributes.stringSettings)
            .concat($scope.patAttributes.doubleSettings)
            .concat($scope.patAttributes.integerSettings)
            .concat($scope.patAttributes.enumSettings)
            .concat($scope.patAttributes.booleanSettings)
            .concat($scope.patAttributes.dateSettings);
        $scope.orderedSettings.sort(compare);
    }
    $scope.initOrderSettings();

    $scope.$watch(function() {
        return $scope.patAttributes
    }, function(newValue, oldValue) {
        if (newValue !== oldValue) {
            $scope.orderedSettings.length = 0;
            $scope.initOrderSettings();
        }
    });
}